import React, { Component } from "react";
import { connect } from "react-redux";
import classnames from "classnames";
import { CircularProgress } from "@material-ui/core";

import Table from "./Table";
import ProcessList from "./ProcessList";
import ProcessModal from "./modals/ProcessModal";
import ReferenceModal from "./modals/ReferenceModal";
import ApprovalModal from "./modals/ApprovalModal";
import CommentModal from "./modals/CommentModal";
import InfoModal from "./modals/InfoModal";
import ScrollArrow from "./ScrollArrow";
import FloatingActionButton from "./FloatingActionButton";
import ContributorModal from "./modals/ContributorModal";
import ErrorIndicator from "./ErrorIndicator";

import { hideError } from "../actions/processActions";
import { addVisitor } from "../actions/adminActions";

import "../styles/main.scss";

class Main extends Component {
  constructor(props) {
    super(props);

    this.props.addVisitor();

    this.state = {};
  }
  render() {
    return (
      <div className="app">
        <ProcessModal />
        <ReferenceModal />
        <ApprovalModal />
        <InfoModal />
        <ContributorModal />
        <CommentModal />
        <Table />
        <br />
        <ProcessList />
        <FloatingActionButton />
        <CircularProgress
          size={60}
          className={classnames("loadingIndicator", {
            "loadingIndicator--visible": this.props.loading
          })}
        />
        <ScrollArrow visible={this.props.showScrollArrow} />
        <ErrorIndicator
          open={this.props.errorShown}
          error={this.props.errorText}
          onClick={this.props.hideError}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    loading: state.process.loading,
    showScrollArrow: state.process.showScrollArrow,
    errorText: state.error.text,
    errorShown: state.error.shown
  };
}

export default connect(
  mapStateToProps,
  { hideError, addVisitor }
)(Main);
